(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgplate-mystery-pack-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tcgplate-pack')) return;
  const clamp = (n, a=0, b=1) => Math.min(b, Math.max(a,n));
  const ease = t => 1 - (1-t)**3;
  class TCGplatePack extends HTMLElement {
    connectedCallback() {
      if (this.live) return;
      this.live=true; this.abort=new AbortController(); this.generation=0; this.frames=new Set(); this.animations=new Set(); this.timers=new Set();this.pendingTweens=new Set();
      this.q=s=>this.querySelector(s); this.qa=s=>[...this.querySelectorAll(s)];
      this.text=JSON.parse(this.q('[data-tp-config]').textContent);
      this.dialog=this.q('dialog'); this.wrapper=this.q('[data-tp-wrapper]'); this.stack=this.q('[data-tp-stack]');
      this.strip=this.q('[data-tp-strip]');this.foilMarkup??=this.strip.innerHTML;this.strip.innerHTML=this.foilMarkup; this.attached=this.strip.cloneNode(true); this.attached.removeAttribute('data-tp-strip'); this.attached.setAttribute('data-tp-attached',''); this.wrapper.append(this.attached);
      this.cards=this.qa('[data-tp-card-index]'); this.reward=this.q('[data-tp-reward]');
      this.form=this.q('form');
      // DAS FORMULAR ZEIGT AUF DIE AKTUELLE SEITE, NICHT AUF /contact
      // (13.09.2026). Shopifys Kundenformular-Tag schreibt
      // action="/contact#...", und /contact ist in diesem Shop eine
      // 404. Solange JavaScript abfaengt, faellt das nicht auf - aber
      // der native Weg nach einer Shopify-Pruefung (nativeFallback)
      // landet dort, und dann ist das Fenster weg und es gibt kein
      // Feedback. Gemessen: POST auf die aktuelle Seite liefert die
      // Seite MIT data-tp-result, und /?customer_posted=true rendert
      // "success" - genau das, was die Wiederaufnahme unten sucht.
      // form_type steuert die Verarbeitung, nicht die Adresse.
      if(this.form){try{const ziel=new URL(location.pathname+location.search,location.href);ziel.searchParams.delete('customer_posted');this.form.setAttribute('action',ziel.pathname+ziel.search+'#'+this.form.id);}catch{}}
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)'); this.coarse=matchMedia('(pointer: coarse)');
      this.key='tcgplate-pack:v1';
      this.completedKey=this.key+':subscribed';this.tabKey=this.key+':tabAus';this.tabWeg=false;try{this.tabWeg=localStorage.getItem(this.tabKey)==='true';}catch{}this.gesehenKey=this.key+':gesehen';this.gesehen=false;try{this.gesehen=localStorage.getItem(this.gesehenKey)==='true';}catch{}
      this.abgeschlossen=this.dataset.subscriber==='true';
      try{this.abgeschlossen=this.abgeschlossen||localStorage.getItem(this.completedKey)==='true';}catch{} this.sessionShown=false; this.interacted=false; this.selected=''; this.nativeFallback=false;
      this.on(this.q('[data-tp-close]'),'click',()=>this.close());
      this.on(this.dialog,'cancel',e=>{e.preventDefault();this.close();});
      this.on(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}});
      this.qa('[data-tp-choice]').forEach(b=>{
        b.querySelector('.tcgplate-pack-wrapper')?.remove();
        const foil=this.wrapper.cloneNode(true);foil.querySelector('[data-tp-attached]')?.remove();foil.querySelector('[data-tp-strip]').innerHTML=this.attached.innerHTML;
        [foil,...foil.querySelectorAll('*')].forEach(el=>[...el.attributes].filter(a=>a.name.startsWith('data-tp-')).forEach(a=>el.removeAttribute(a.name)));
        foil.classList.add('tcgplate-pack-mini');b.prepend(foil);b.setAttribute('aria-label',this.text.pack_label.replace('{number}',b.dataset.tpChoice));
        this.on(b,'click',()=>this.choosePack(b));
      });
      this.setupRibbon();
      const email=this.q('[type="email"]'),consent=this.q('[type="checkbox"]');
      this.on(email,'invalid',()=>email.setCustomValidity(this.text.email_invalid));
      this.on(email,'input',()=>email.setCustomValidity(''));
      this.on(consent,'invalid',()=>consent.setCustomValidity(this.text.consent_required));
      this.on(consent,'change',()=>consent.setCustomValidity(''));
      this.gesture(this.q('[data-tp-open]'),'pack'); this.gesture(this.q('[data-tp-card]'),'card');
      this.on(this.form,'submit',e=>this.submit(e));
      this.on(window,'resize',()=>this.resetGesture());
      this.on(this.reduced,'change',()=>{if(this.reduced.matches&&this.phase==='revealing')this.revealImmediately();else if(this.reduced.matches&&this.phase==='opening')this.finishOpening();});
      // `force`, weil ein Klick eine Absicht ist: Ohne das blockt die
      // eigene Sieben-Tage-Sperre aus close() den Wiederoeffner aus.
      this.on(document,'tcgplate:pack:open',()=>this.open(true));
      this.on(document,'click',e=>{if(e.target.closest?.('[data-tcgplate-pack-open]')&&this.dataset.enabled==='true'){e.preventDefault();this.open(true);}});
      this.on(document,'DOMContentLoaded',()=>this.syncEntrypoints());
      this.on(document,'shopify:section:load',()=>this.syncEntrypoints());
      this.on(window,'storage',e=>{if(e.key===this.completedKey&&e.newValue==='true'){this.abgeschlossen=true;this.tabAn(false);}});
      this.on(this.q('[data-tp-tab]'),'click',e=>{
        // Das X blendet den Reiter dauerhaft aus, statt zu oeffnen.
        if(e.target.closest?.('[data-tp-tab-x]')){e.preventDefault();e.stopPropagation();this.tabAus();return;}
        this.tabAn(false);this.open(true);});
      const fertig=this.q('[data-tp-done]');
      if(fertig)this.on(fertig,'click',()=>{this.abgeschlossen=true;this.tabAn(false);this.close();});
      this.on(document,'pointerdown',()=>{this.interacted=true;this.tryAuto();},{passive:true});
      this.on(document,'keydown',()=>{this.interacted=true;this.tryAuto();});
      this.on(window,'scroll',()=>{this.interacted=true;this.tryAuto();},{passive:true});
      this.on(document,'visibilitychange',()=>{if(document.hidden)this.resetGesture();else this.tryAuto();});
      // AUSLOESER WARENKORB (Philipp 01.10.2026): Wer sich nur umsieht, wird nicht
      // unterbrochen. Erst wenn genug im Korb liegt und der Korb wieder zu ist,
      // darf das Pack von selbst kommen. Gezaehlt wird ueber /cart.js.
      const zaehlen=()=>{if(this.dataset.autoMode!=='warenkorb')return;fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{this.cartCount=Number(c.item_count)||0;this.tryAuto();}).catch(()=>{});};
      this.on(window,'cart:updated',()=>this.later(zaehlen,400));
      this.on(document,'cart:updated',()=>this.later(zaehlen,400));
      this.on(document,'tcgp:cart-drawer-close',()=>this.later(()=>this.tryAuto(),900));
      this.later(zaehlen,1500);
      this.on(window,'pageshow',()=>{this.q('[data-tp-submit]').disabled=false;this.q('[data-tp-submit]').textContent=this.text.submit;this.tabAn(this.dataset.enabled==='true'&&!this.dialog.open);});
      this.started=performance.now(); this.reset();this.syncEntrypoints();this.tabAn(this.dataset.enabled==='true');
      const result=this.q('[data-tp-result]');
      let pending=false; try{const p=JSON.parse(sessionStorage.getItem(this.id)||'null');pending=!!p&&Date.now()-p.at<15*60000;}catch{}
      if(pending&&result?.dataset.tpResult==='success'){this.open(true);this.revealImmediately();this.success();try{sessionStorage.removeItem(this.id);}catch{}}
      else if(pending&&result?.dataset.tpResult==='error'){this.open(true);this.revealImmediately();if(this.isAlreadyRegistered(result))this.success('already');else this.error(result.textContent||this.text.error);try{sessionStorage.removeItem(this.id);}catch{}}
      else if(this.dataset.editor==='true'){this.open(true);}
      else this.later(()=>this.tryAuto(),Math.max(1000,Number(this.dataset.delay)*1000));
    }
    disconnectedCallback(){document.querySelectorAll('[data-tcgp-footer]').forEach(f=>f.removeAttribute('data-tp-available'));this.live=false;this.abort?.abort();this.cancelWork();this.request?.abort();this.attached?.remove();if(this.dialog?.open){this.dialog.close();this.unlockScroll();}this.timers?.forEach(clearTimeout);}
    on(target,event,fn,options={}){target.addEventListener(event,fn,{...options,signal:this.abort.signal});}
    later(fn,ms){const id=setTimeout(()=>{this.timers.delete(id);if(this.live)fn();},ms);this.timers.add(id);return id;}
    scrollPct(){const d=document.documentElement;const max=d.scrollHeight-window.innerHeight;if(max<=0)return 100;return (window.scrollY/max)*100;}
    storeUntil(days){this.sessionShown=true;try{localStorage.setItem(this.key,String(Date.now()+days*86400000));}catch{}}
    suppressed(){if(this.abgeschlossen||this.sessionShown||this.dataset.subscriber==='true')return true;try{return Number(localStorage.getItem(this.key))>Date.now();}catch{return false;}}
    otherOverlay(){
      const selectors=['dialog[open]','[aria-modal="true"]','.tcgp-mystery[data-open="true"]',this.dataset.overlaySelector].filter(Boolean).join(',');
      // UNSER WARENKORB VERSTECKT SICH PER TRANSFORM (12.09.2026).
      //
      // `.tcgp-cd__panel` traegt aria-modal dauerhaft, bleibt sichtbar
      // und wird nur um 452 px aus dem Fenster geschoben. Fuer die alte
      // Pruefung war er ein offenes Overlay, und das Popup ging nie auf -
      // gemessen im Browser, nicht vermutet. Deshalb zusaetzlich: liegt
      // der Mittelpunkt ueberhaupt im Fenster?
      try{return [...document.querySelectorAll(selectors)].some(e=>{
        if(this.contains(e)||!e.getClientRects().length)return false;
        const s=getComputedStyle(e);
        if(s.visibility==='hidden'||s.display==='none'||Number(s.opacity)===0)return false;
        const r=e.getBoundingClientRect();
        const x=r.left+r.width/2,y=r.top+r.height/2;
        return x>0&&y>0&&x<window.innerWidth&&y<window.innerHeight;
      });}catch{return true;}
    }
    tryAuto(){
      // Startseite: nie von selbst. Philipp 13.09.2026 - das Kino
      // soll niemanden aus dem Fluss reissen. Der Footer-Einstieg
      // ruft open(true) und kommt hier nicht vorbei.
      if(this.dataset.homePage==='true')return;
      // Auslöser (01.10.2026): 'aus' = nie von selbst, nur Reiter und Fusszeile;
      // 'warenkorb' = erst ab N Produkten im Korb; 'scroll' = wie bis 30.09. (Scrolltiefe).
      const modus=this.dataset.autoMode||'warenkorb';
      if(modus==='aus')return;
      if(this.dataset.enabled!=='true'||this.dataset.editor==='true'||document.hidden||this.suppressed()||this.dialog.open)return;
      if(modus==='warenkorb'){if(!((this.cartCount||0)>=Number(this.dataset.cartThreshold||2)))return;}
      else{if(!this.interacted)return;if(this.scrollPct()<Number(this.dataset.scrollDepth||50))return;}
      if(this.otherOverlay()){if(!this.autoRetry)this.autoRetry=this.later(()=>{this.autoRetry=null;this.tryAuto();},3000);return;}
      this.open();
    }
    open(force=false){
      if(this.dialog.open)return;
      if(!force&&(this.dataset.subscriber==='true'||this.otherOverlay()))return;
      this.returnFocus=document.activeElement;this.reset();this.sessionShown=true;this.gesehen=true;try{localStorage.setItem(this.gesehenKey,'true');}catch{}this.dialog.showModal();this.tabAn(false);this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.scrollLocked=true;
      this.q('[data-tp-title]').tabIndex=-1;this.q('[data-tp-title]').focus({preventScroll:true});
    }
    unlockScroll(){if(this.scrollLocked&&document.documentElement.style.overflow==='hidden')document.documentElement.style.overflow=this.previousOverflow;this.scrollLocked=false;}
    close(){this.resetGesture();this.cancelWork();this.request?.abort();this.dialog.close();this.unlockScroll();this.storeUntil(Number(this.dataset.dismissDays)||7);this.tabAn(!this.abgeschlossen);this.returnFocus?.focus?.({preventScroll:true});}
    cancelWork(){this.generation++;this.frames.forEach(id=>cancelAnimationFrame(id));this.frames.clear();this.pendingTweens.forEach(resolve=>resolve(false));this.pendingTweens.clear();this.animations.forEach(a=>a.cancel());this.animations.clear();}
    reset(){
      this.cancelWork();this.pointer=null;this.suppressClickUntil=0;this.progress=0;delete this.dataset.released;delete this.dataset.pack;
      this.qa('[data-tp-choice]').forEach(b=>{b.removeAttribute('style');b.disabled=false;b.querySelector('.tcgplate-pack-mini').style.visibility='';});
      this.selected='';this.q('[data-tp-tags]').value='newsletter,tcgplate-pack';
      [this.wrapper,this.stack,this.strip,this.attached,this.reward,...this.cards].forEach(e=>{e.removeAttribute('style');e.hidden=false;});
      this.cards.forEach((c,i)=>{c.style.zIndex=String(8-i);c.style.transform=`translate(${(5-i)*.5}px,${(5-i)*1.8}px)`;});
      this.stack.removeAttribute('data-removed');this.wrapper.hidden=false;this.q('[data-tp-tear]').style.opacity='1';this.setTear(0);
      this.form.hidden=false;this.form.removeAttribute('aria-busy');this.q('[data-tp-success]').hidden=true;this.q('[data-tp-error]').hidden=true;
      this.q('[data-tp-submit]').disabled=false;this.q('[data-tp-submit]').textContent=this.text.submit;this.nativeFallback=false;
      this.phaseTo(this.dataset.choice==='false'?'closed':'choice');
    }
    phaseTo(phase){
      this.phase=phase;this.dataset.phase=phase;
      const form=phase==='form', cover=phase==='cover', closed=phase==='closed', choice=phase==='choice'||phase==='selecting';
      this.q('[data-tp-choices]').hidden=!choice;this.q('[data-tp-form-panel]').hidden=!form;
      this.q('[data-tp-open]').hidden=!closed;this.q('[data-tp-card]').hidden=!cover;
      const keys=choice?['choose_title','choose_description']:closed?['pack_title','pack_description']:form?['form_title','form_description']:['cover_title','cover_description'];
      this.q('[data-tp-title]').textContent=this.text[keys[0]];this.q('[data-tp-description]').textContent=this.text[keys[1]];
      this.q('[data-tp-gesture]').textContent=choice?this.text.choose_hint:closed?this.text[this.coarse.matches?'swipe_hint':'click_hint']:cover?this.text[this.coarse.matches?'drag_hint':'discover_hint']:form?this.text.reward_caption:'';
      this.q('[data-tp-status]').textContent='';
      this.reward.setAttribute('aria-hidden',String(!form));
      this.dispatchEvent(new CustomEvent('tcgplate:pack:state',{bubbles:true,detail:{phase,removed:Number(this.stack.dataset.removed||0)}}));
    }
    tween(duration,draw,curve=ease){
      const generation=this.generation; const start=performance.now(); if(this.reduced.matches)duration=1;
      return new Promise(resolve=>{this.pendingTweens.add(resolve);const done=result=>{this.pendingTweens.delete(resolve);resolve(result);};const tick=now=>{if(generation!==this.generation||!this.live){done(false);return;}const t=clamp((now-start)/duration);draw(curve(t));if(t===1){done(true);return;}const id=requestAnimationFrame(n=>{this.frames.delete(id);tick(n);});this.frames.add(id);};tick(start);});
    }
    async animate(el,keyframes,duration,delay=0,easing='cubic-bezier(.18,.72,.18,1)'){
      const a=el.animate(keyframes,{duration:this.reduced.matches?1:duration,delay:this.reduced.matches?0:delay,easing,fill:'forwards'});this.animations.add(a);
      try{await a.finished;a.commitStyles();a.cancel();this.animations.delete(a);return true;}catch{this.animations.delete(a);return false;}
    }
    async choosePack(button){
      if(this.phase!=='choice')return;
      const generation=this.generation,mini=button.querySelector('.tcgplate-pack-mini'),from=mini.getBoundingClientRect();
      this.selected=button.dataset.tpChoice;this.dataset.pack=this.selected;this.phaseTo('selecting');
      this.qa('[data-tp-choice]').forEach(b=>{b.disabled=true;if(b!==button)this.animate(b,[{opacity:1,translate:'0 0'},{opacity:0,translate:`${b.dataset.tpChoice<this.selected?-35:35}px 24px`}],360);});
      mini.style.visibility='hidden';
      this.wrapper.style.transform='none';
      const to=this.wrapper.getBoundingClientRect(),scale=from.width/this.wrapper.offsetWidth;
      const dx=from.left+from.width/2-(to.left+to.width/2),dy=from.top+from.height/2-(to.top+to.height/2);
      if(!await this.animate(this.wrapper,[{transform:`translate(${dx}px,${dy}px) scale(${scale}) rotate(0deg)`},{transform:'translate(0,0) scale(1) rotate(-5deg)'}],720))return;
      if(generation!==this.generation)return;
      this.wrapper.style.removeProperty('transform');this.phaseTo('closed');this.q('[data-tp-open]').focus({preventScroll:true});
    }
    setupRibbon(){
      const id=this.id+'-ribbon';
      this.strip.innerHTML=`<svg class="tcgplate-pack-ribbon" viewBox="0 0 230 41" preserveAspectRatio="none" aria-hidden="true"><defs><linearGradient id="${id}-foil"><stop stop-color="#b9942d"/><stop offset=".15" stop-color="#fff1a0"/><stop offset=".48" stop-color="var(--tp-yellow)"/><stop offset=".8" stop-color="#fbe88d"/><stop offset="1" stop-color="#c09625"/></linearGradient><pattern id="${id}-crimp" width="4" height="41" patternUnits="userSpaceOnUse"><path d="M1 -100V100" stroke="#fff" stroke-opacity=".28"/><path d="M2 -100V100" stroke="#5c4517" stroke-opacity=".18"/></pattern><clipPath id="${id}-clip"><path data-tp-ribbon-clip/></clipPath></defs><path data-tp-ribbon-shape fill="url(#${id}-foil)"/><path data-tp-ribbon-texture fill="url(#${id}-crimp)"/><path data-tp-ribbon-light fill="none" stroke="#fff4b1" stroke-width="1.2"/><text data-tp-ribbon-label clip-path="url(#${id}-clip)" x="12" font-size="4.8" letter-spacing=".7" fill="#38311d"></text></svg>`;
      this.q('[data-tp-ribbon-label]').textContent=this.text.tear_caption;
    }
    setTear(p){
      this.progress=clamp(p);this.dataset.tear=this.progress.toFixed(3);
      const cut=this.progress*100,x=this.progress*230,h=41,lift=this.progress*58;
      this.attached.style.clipPath=`inset(0 0 0 ${cut}%)`;
      this.strip.style.clipPath='none';this.strip.style.transform='none';
      const top=`M 0 ${-lift} C ${x*.42} ${-lift}, ${x*.62} 0, ${x} 0`;
      const bottom=`M 0 ${h-lift} C ${x*.42} ${h-lift}, ${x*.62} ${h}, ${x} ${h}`;
      const shape=top+` L ${x} ${h} C ${x*.62} ${h}, ${x*.42} ${h-lift}, 0 ${h-lift} Z`;
      ['shape','texture','clip'].forEach(part=>this.q('[data-tp-ribbon-'+part+']').setAttribute('d',shape));
      this.q('[data-tp-ribbon-light]').setAttribute('d',bottom);
      this.q('[data-tp-ribbon-label]').setAttribute('y',String(30-lift));
      this.q('[data-tp-tear]').style.width=cut+'%';
    }
    gesture(hit,kind){
      const allowed=()=>this.phase===(kind==='pack'?'closed':'cover');
      this.on(hit,'pointerdown',e=>{
        if(!allowed()||this.pointer||e.button!==0||e.isPrimary===false)return;
        this.cancelWork();
        this.suppressClickUntil=0;
        this.pointer={id:e.pointerId,kind,x:e.clientX,y:e.clientY,lastX:e.clientX,lastTime:e.timeStamp,v:0,dx:0,moved:false,hit};
        hit.setPointerCapture(e.pointerId);
      });
      this.on(hit,'pointermove',e=>{
        const p=this.pointer;if(!p||p.id!==e.pointerId)return;
        const dx=e.clientX-p.x,dy=e.clientY-p.y;const dt=e.timeStamp-p.lastTime;
        if(dt>0)p.v=(e.clientX-p.lastX)/dt;p.lastX=e.clientX;p.lastTime=e.timeStamp;p.dx=dx;
        if(Math.hypot(dx,dy)>7)p.moved=true;
        if(!p.moved)return;
        if(kind==='pack')this.setTear(dx/(hit.getBoundingClientRect().width*.85));
        else{this.flip=clamp(dx/hit.clientWidth*180,-170,170);this.setFlip(this.flip);}
      });
      const finish=(e,cancelled=false)=>{
        const p=this.pointer;if(!p||p.id!==e.pointerId)return;this.pointer=null;
        if(hit.hasPointerCapture(e.pointerId))hit.releasePointerCapture(e.pointerId);
        if(cancelled||p.moved){this.suppressClickUntil=performance.now()+650;}
        if(cancelled){this.springBack(kind);return;}
        if(!p.moved)return;
        const velocity=e.timeStamp-p.lastTime<100?p.v:0;
        if(kind==='pack'){if(this.progress>=.62)this.openPack();else this.springBack(kind);}
        else if(Math.abs(p.dx)>hit.clientWidth*.3||(Math.abs(velocity)>.55&&Math.abs(p.dx)>22))this.removeCover(p.dx,velocity);
        else this.springBack(kind);
      };
      this.on(hit,'pointerup',e=>finish(e));this.on(hit,'pointercancel',e=>finish(e,true));this.on(hit,'lostpointercapture',e=>finish(e,true));
      this.on(hit,'click',e=>{if(performance.now()<this.suppressClickUntil){e.preventDefault();e.stopPropagation();return;}if(allowed()){if(kind==='pack'){if(e.detail===0)this.openPack();}else this.removeCover();}});
    }
    resetGesture(){if(!this.pointer)return;const p=this.pointer;this.pointer=null;this.suppressClickUntil=performance.now()+650;if(p.hit.hasPointerCapture(p.id))p.hit.releasePointerCapture(p.id);this.springBack(p.kind);}
    async springBack(kind){
      if(kind==='pack'){const p=this.progress;await this.tween(220,t=>this.setTear(p*(1-t)));}
      else{const angle=this.flip||0;await this.tween(290,t=>this.setFlip(angle*(1-t)));}
    }
    async openPack(){
      if(this.phase!=='closed')return; this.cancelWork();this.phaseTo('opening');const generation=this.generation;
      const p=this.progress;if(!await this.tween(560*(1-p)+100,t=>this.setTear(p+(1-p)*t)))return;
      this.dataset.released='true';this.attached.hidden=true;this.q('[data-tp-tear]').style.opacity='0';
      const stripFrom=this.strip.style.transform;
      const stripFlight=this.animate(this.strip,[{transform:stripFrom,opacity:1},{transform:'translate(-110px,-90px) rotate(-34deg) skewY(16deg)',opacity:0}],430);
      const stackRise=this.animate(this.stack,[{transform:'translateY(20px) rotate(-5deg)'},{transform:'translateY(-32px) rotate(-1deg)',offset:.6},{transform:'translateY(0) rotate(0deg)'}],690,100);
      const wrapperExit=this.animate(this.wrapper,[{transform:'rotate(-5deg)',opacity:1},{transform:'translateY(90px) rotate(0deg)',opacity:1,offset:.36},{transform:'translateY(370px) rotate(15deg)',opacity:0}],680,180);
      await Promise.all([stripFlight,stackRise,wrapperExit]);if(generation!==this.generation)return;this.wrapper.hidden=true;
      const flights=this.cards.slice(0,5).map((c,i)=>this.animate(c,[{transform:c.style.transform,opacity:1},{transform:`translate(-${240+i*14}px,-${50+i*8}px) rotate(-${18+i*2}deg)`,opacity:.9,offset:.7},{transform:`translate(-${390+i*15}px,-${80+i*10}px) rotate(-${27+i*2}deg)`,opacity:0}],420,i*145,'cubic-bezier(.35,.03,.35,1)').then(ok=>{if(ok&&generation===this.generation){c.hidden=true;this.stack.dataset.removed=String(i+1);}}));
      flights.push(this.tween(1000,t=>{for(let i=1;i<6;i++)if(!this.cards[i].hidden)this.cards[i].style.translate=`0 ${(5-i)*-1.8*t}px`;}));
      await Promise.all(flights);if(generation!==this.generation)return;
      this.cards[5].style.transform='translate(0px,0px)';this.setFlip(0);this.phaseTo('cover');this.q('[data-tp-card]').focus({preventScroll:true});
    }
    setFlip(angle){
      this.flip=angle;const progress=Math.abs(angle)/180;const turn=angle<0?-180:180;
      const scale=1+Math.sin(progress*Math.PI)*.085;
      this.cards[5].style.transform=`scale(${scale}) rotateY(${angle}deg)`;
      this.reward.style.transform=`scale(${scale}) rotateY(${angle-turn}deg)`;
      this.reward.style.boxShadow=`0 ${12+Math.sin(progress*Math.PI)*18}px 32px #3e361833`;
    }
    finishOpening(){this.dataset.released='true';this.cancelWork();this.wrapper.hidden=true;this.stack.style.transform='translateY(0) rotate(0deg)';this.cards.forEach((c,i)=>{c.hidden=i<5;});this.stack.dataset.removed='5';this.setFlip(0);this.phaseTo('cover');this.q('[data-tp-card]').focus({preventScroll:true});}
    async removeCover(dx=0,velocity=0){
      if(this.phase!=='cover')return;this.phaseTo('revealing');const generation=this.generation;const c=this.cards[5];
      const start=this.flip||0;const dir=start?Math.sign(start):(dx?Math.sign(dx):1);const duration=clamp((180-Math.abs(start))*4-Math.abs(velocity)*80,220,740);
      if(!await this.tween(duration,t=>this.setFlip(start+(dir*180-start)*t),t=>t<.5?4*t*t*t:1-(-2*t+2)**3/2))return;
      if(generation!==this.generation)return;c.hidden=true;this.stack.dataset.removed='6';
      await this.animate(this.reward,[{transform:'scale(1) rotateY(0deg)'},{transform:'scale(1.055) rotateY(0deg) rotate(-1deg)'}],260);
      this.animate(this.q('.tcgplate-pack-reward-shine'),[{transform:'translateX(-130%)'},{transform:'translateX(130%)'}],800);
      if(generation===this.generation)this.showForm();
    }
    showForm(){
      const before=this.reward.getBoundingClientRect();this.phaseTo('form');const after=this.reward.getBoundingClientRect();
      if(!this.reduced.matches&&after.width>0){const target=Number.parseFloat(getComputedStyle(this.stack).scale)||1;const generation=this.generation;this.animate(this.stack,[{translate:`${before.x-after.x}px ${before.y-after.y}px`,scale:String(target*before.width/after.width)},{translate:'0 0',scale:String(target)}],420).then(()=>{if(generation===this.generation){this.stack.style.removeProperty('scale');this.stack.style.removeProperty('translate');}});this.animate(this.q('[data-tp-form-panel]'),[{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],420,0);}
      this.q('[data-tp-title]').tabIndex=-1;this.q('[data-tp-title]').focus({preventScroll:true});
    }
    revealImmediately(){
      if(this.phase==='form')return;this.dataset.released='true';this.cancelWork();this.pointer=null;this.wrapper.hidden=true;this.cards.forEach(c=>c.hidden=true);this.stack.style.transform='translateY(0) rotate(0deg)';this.stack.dataset.removed='6';this.reward.style.transform='scale(1.055) rotate(-1deg)';this.showForm();
    }
    error(message){this.q('[data-tp-error]').textContent=message;this.q('[data-tp-error]').hidden=false;this.q('[data-tp-error]').scrollIntoView({block:'nearest'});}
    isAlreadyRegistered(result){
      if(!result||result.dataset.tpResult!=='error')return false;
      const message=result.textContent.trim().replace(/\s+/g,' ');
      const emailError=(result.dataset.tpErrorFields||'').split(',').includes('email')||/e[\s-]?mail/i.test(message);
      return emailError&&/(?:already (?:been )?(?:registered|subscribed|taken|used)|already exists|bereits (?:registriert|abonniert|hinterlegt|verwendet|vorhanden|vergeben)|schon (?:registriert|abonniert|hinterlegt)|wird bereits verwendet)/i.test(message);
    }
    submissionOutcome(res,html){
      const doc=new DOMParser().parseFromString(html,'text/html');
      const result=doc.getElementById(this.id)?.querySelector('[data-tp-result]')||doc.getElementById(this.form.id)?.querySelector('[data-tp-result]');
      if(result?.dataset.tpResult==='success')return {kind:'success'};
      if(result?.dataset.tpResult==='error')return this.isAlreadyRegistered(result)?{kind:'already'}:{kind:'error',message:result.textContent.trim()||this.text.error};
      // Only Shopify's explicit success redirect, never arbitrary HTTP 200 or page text.
      const finalUrl=new URL(res.url||location.href,location.href);
      if(res.ok&&finalUrl.origin===location.origin&&finalUrl.searchParams.get('customer_posted')==='true')return {kind:'success'};
      return {kind:'unconfirmed'};
    }
    success(kind='success'){
      const already=kind==='already';this.nativeFallback=false;
      this.q('[data-tp-error]').hidden=true;this.form.hidden=true;this.q('[data-tp-success]').hidden=false;
      this.q('[data-tp-title]').textContent=this.text[already?'already_title':'success_title'];
      this.q('[data-tp-description]').textContent='';
      const heading=this.q('.tcgplate-pack-success-title');heading.textContent=this.text[already?'already_heading':'success_heading'];
      this.q('.tcgplate-pack-success-text').textContent=this.text[already?'already':'success'];
      this.q('[data-tp-status]').textContent='';
      this.abgeschlossen=true;try{localStorage.setItem(this.completedKey,'true');sessionStorage.removeItem(this.id);}catch{}
      this.tabAn(false);this.storeUntil(Number(this.dataset.successDays)||90);
      heading.focus({preventScroll:true});this.q('[data-tp-success]').scrollIntoView({block:'nearest'});
    }
    // Der Wiederoeffner: sichtbar nur, wenn jemand weggeklickt hat, ohne
    // sich anzumelden. Nach einem Erfolg nie, und fuer Abonnenten auch nicht.
    // Der Reiter laesst sich dauerhaft wegklicken (13.09.2026).
    // Philipp: wenn einem das auf den Sack geht, kann man es ganz
    // wegklicken. Die Entscheidung gilt fuer diesen Browser;
    // das Popup bleibt ueber den Fusszeilen-Link erreichbar.
    tabAus(){this.tabWeg=true;try{localStorage.setItem(this.tabKey,'true');}catch{}this.tabAn(false);}
    tabAn(zeigen){const t=this.q('[data-tp-tab]');if(!t)return;
      // Philipp 03.10.2026: Reiter erst, nachdem das Pack einmal aufging - dann bleibt er bis zum X.
      t.hidden=!zeigen||!this.gesehen||this.tabWeg||this.dataset.productPage==='true'||this.dataset.homePage==='true'||this.abgeschlossen||this.dataset.subscriber==='true'||this.dataset.editor==='true'||this.dialog.open;}
    syncEntrypoints(){document.querySelectorAll('[data-tcgp-footer]').forEach(f=>f.toggleAttribute('data-tp-available',this.dataset.enabled==='true'));}
    async submit(event){
      if(this.phase!=='form'){event.preventDefault();return;}
      if(!this.form.checkValidity()){event.preventDefault();this.form.reportValidity();return;}
      if(this.nativeFallback){try{sessionStorage.setItem(this.id,JSON.stringify({at:Date.now()}));}catch{}return;}
      event.preventDefault();event.stopPropagation();if(this.request)return;
      const button=this.q('[data-tp-submit]');button.disabled=true;button.textContent=this.text.sending;this.form.setAttribute('aria-busy','true');this.q('[data-tp-error]').hidden=true;
      const request=this.request=new AbortController();let timedOut=false;const timer=setTimeout(()=>{timedOut=true;request.abort();},18000);const generation=this.generation;
      try{
        let response;
        const demo=new CustomEvent('tcgplate:pack:preview-submit',{cancelable:true,detail:{respond:promise=>{response=promise;}}});
        this.dispatchEvent(demo);
        if(demo.defaultPrevented&&response){const result=await response;if(generation!==this.generation)return;if(result.ok)this.success(result.kind);else this.error(result.message);return;}
        // AN DIE AKTUELLE SEITE, NICHT AN /contact (12.09.2026).
        //
        // Das Kundenformular von Shopify schreibt action="/contact#...", und bei
        // uns ist /contact eine 404. Shopify verarbeitet die Anmeldung
        // trotzdem (die Rabattmail kam), liefert aber eine Seite ohne unser
        // Ergebniselement; der Adapter meldete dann „kein eindeutiger
        // Anmeldestatus". `form_type` steuert die Verarbeitung, nicht die
        // Adresse - gegengeprueft mit einer ungueltigen Mail: POST auf "/"
        // liefert die Seite MIT tp-result.
        const url=new URL(location.pathname+location.search,location.href);
        url.searchParams.delete('customer_posted');
        const res=await fetch(url,{method:'POST',body:new URLSearchParams(new FormData(this.form)),credentials:'same-origin',signal:request.signal});
        if(generation!==this.generation)return;
        if(res.status===429){this.error(this.text.rate_limit);return;}
        if(res.url.includes('/challenge')||res.status===403){this.nativeFallback=true;this.error(this.text.challenge);return;}
        // Erst das Element suchen, DANN ueber den Status urteilen: Shopify
        // gibt bei Formularfehlern den Status der Ursprungsseite mit, im
        // Test eine 404 bei voll brauchbarem Inhalt.
        const html=await res.text();if(generation!==this.generation)return;
        const outcome=this.submissionOutcome(res,html);
        if(outcome.kind==='success'||outcome.kind==='already')this.success(outcome.kind);
        else if(outcome.kind==='error')this.error(outcome.message);
        else if(!res.ok)throw Error('HTTP '+res.status);
        else this.error(this.text.unconfirmed); // Stay here; no automatic fallback POST or navigation.
      }catch(e){if(generation===this.generation&&(e.name!=='AbortError'||timedOut))this.error(this.text.network_error);}
      finally{clearTimeout(timer);if(this.request===request){this.request=null;if(generation===this.generation){button.disabled=false;button.textContent=this.nativeFallback?this.text.native_submit:this.text.submit;this.form.removeAttribute('aria-busy');}}}
    }
  }
  customElements.define('tcgplate-pack',TCGplatePack);
})();


  } catch(e) { console.error(e); }
})();
})();
